import firebase from "firebase-app"
import { fetchFromLocalStorage, storeInLocalStorage } from "store/localStorage"

const TOKEN_KEY = "token"
const USER_TYPE = "userType"

export const getToken = () => {
  return fetchFromLocalStorage({
    key: TOKEN_KEY
  })
}

export const setToken = token => {
  return storeInLocalStorage({
    key: TOKEN_KEY,
    value: token
  })
}

export const getUserType = () => {
  return fetchFromLocalStorage({
    key: USER_TYPE
  })
}

export const setUserType = userType => {
  return storeInLocalStorage({
    key: USER_TYPE,
    value: userType
  })
}

export const isLoggedIn = () => {
  return !!getToken()
}

export const logout = () => {
  storeInLocalStorage({ key: "token", value: null })

  console.log("logout...")

  firebase
    .auth()
    .signOut()
    .then(
      function() {
        console.log("Signed Out")
        window.location.href = "/"
        return false
      },
      function(error) {
        console.error("Sign Out Error", error)
        return false
      }
    )
}
